module.exports = __webpack_public_path__ + "static/favicon-512-ca265c3e881a1568a03069c3dfa7e9ef.png";